import React from 'react';
import { useRecoilState } from 'recoil';
import { PostcodeInput } from '~/common/components';
import { VariantPageState } from '../../store';
import { useIsMobile } from '~/common/hooks/use-is-mobile';
import styles from './index.module.scss';

export const VariantHeadingPostcode = React.memo(() => {
  const [{ heading }] = useRecoilState(VariantPageState);
  const { isMobile } = useIsMobile();

  React.useEffect(() => {
    const headingTitle = document.getElementById('headingPostcode');
    if (!headingTitle) return;

    const promoHeight = () => (isMobile() ? 135 : 0);

    const updateHeaderMargin = () => {
      const hasStickyPromo = document.body.classList.contains('sticky-promo');
      let height = promoHeight();

      if (hasStickyPromo) {
        height = promoHeight();
      } else {
        height = 0;
      }

      headingTitle.style.marginTop = `${height}px`;
    };

    updateHeaderMargin();

    const onResize = () => updateHeaderMargin();
    window.addEventListener('resize', onResize);

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          updateHeaderMargin();
          break;
        }
      }
    });
    observer.observe(document.body, { attributes: true });

    return () => {
      window.removeEventListener('resize', onResize);
      observer.disconnect();
    };
  }, [isMobile]);

  return (
    <div className={styles.headingPostcode} id="headingPostcode">
      <div
        className={styles.heading}
        dangerouslySetInnerHTML={{ __html: heading }}
      />

      <PostcodeInput />
    </div>
  );
});
